import { useCallback, useState } from "react";

export const useWarnings = () => {
  const [warning, setWarning] = useState({});

  const showWarning = useCallback(({ title, content, icon }) => {
    setWarning({
      title,
      content,
      icon,
    });
  }, []);

  const hideWarning = useCallback(() => {
    setWarning({});
  }, []);

  return {
    warning,
    showWarning,
    hideWarning,
  };
};
